import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { BoxContainer } from '@/components';

import { GetOfferInner } from './parts';

import { JSX } from 'react';
import styles from './styles.module.scss';

export type GetOfferProps = SliceComponentProps<Content.GetOfferSlice>;

const GetOffer = ({ slice }: GetOfferProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.section}
      id={slice.id}
    >
      <BoxContainer
        styles={`${styles.box_container} ${styles[slice.variation]}`}
      >
        <GetOfferInner slice={slice} />
      </BoxContainer>
    </section>
  );
};

export default GetOffer;
